import TransactionHistoryPage from '@/srm/components/TransactionHistoryPage'

const SrmView = () => {
  return <TransactionHistoryPage />
}

export default SrmView
